/* eslint-disable */
// This code is autogenerated using @harnessio/oats-cli.
// Please do not modify this code directly.
import type { PaginatedCombinedDownloadList } from '../schemas/PaginatedCombinedDownloadList';
import { fetcher, FetcherOptions } from './fetcher';

export interface AssetsMediaContentAssetDownloadsListAPIPathParams {
  /**
   * @format uuid
   */
  id: string;
}

export interface AssetsMediaContentAssetDownloadsListAPIQueryParams {
  ids?: string;
  limit?: number;
  media_source_type?: 'RECORDING' | 'UPLOAD';
  offset?: number;
  ordering?: string;
  /**
   * @format uuid
   */
  organization?: string;
  projects?: string;
  search?: string;
}

export type AssetsMediaContentAssetDownloadsListOkResponse =
  PaginatedCombinedDownloadList;

export type AssetsMediaContentAssetDownloadsListErrorResponse = unknown;

export interface AssetsMediaContentAssetDownloadsListProps
  extends AssetsMediaContentAssetDownloadsListAPIPathParams,
    Omit<
      FetcherOptions<
        AssetsMediaContentAssetDownloadsListAPIQueryParams,
        unknown
      >,
      'url'
    > {
  queryParams: AssetsMediaContentAssetDownloadsListAPIQueryParams;
}

export function assetsMediaContentAssetDownloadsList(
  props: AssetsMediaContentAssetDownloadsListProps
): Promise<AssetsMediaContentAssetDownloadsListOkResponse> {
  return fetcher<
    AssetsMediaContentAssetDownloadsListOkResponse,
    AssetsMediaContentAssetDownloadsListAPIQueryParams,
    unknown
  >({
    url: `/assets/media-content/${props.id}/asset_downloads/`,
    method: 'GET',
    ...props
  });
}
